 
import IndexModel from "@/service/v1/sigap/IndexModel"; 
 
class QtsPdfService extends IndexModel { 
       
    constructor() {
        super(); 
        this.url =  this.url + '/QtsPdf' ;  
    }
 
    public getApiUrl(  ) { 
        return this.getAxios().defaults.baseURL + this.url; 
    }

    
    public cadastrarArquivo(   dados: any ) : Promise<any> {  
        const head = { 'Authorization': this.getAxios().defaults.headers.common["Authorization"] }; 
        head["Content-Type"] = "multipart/form-data";  
        return  new Promise((resolve, reject) => {  
            this.getAxios().post( this.url , dados , { headers: head }   )
            .then(response => {    
                resolve( response.data);  
            })
            .catch(error => {   
                reject(error.response);
            }) 
        }); 
    }

    
    
    public notificar( id:any ) : Promise<any> {   
        return  new Promise((resolve, reject) => {  
            this.getAxios().put( this.url + '/' + id + '/Notificar'   , {}  )
            .then(response => {    
                resolve( response.data);  
            })
            .catch(error => {   
                reject(error.response);
            }) 
        });  
    }  
    


    public atualizarArquivo( id:any,   dados: any ) : Promise<any> {  
        const head = { 'Authorization': this.getAxios().defaults.headers.common["Authorization"] }; 
        head["Content-Type"] = "multipart/form-data";  
        return  new Promise((resolve, reject) => {  
            this.getAxios().put( this.url + '/' + id + '/Arquivo' , dados , { headers: head }   )
            .then(response => {    
                resolve( response.data);  
            })
            .catch(error => {   
                reject(error.response);
            }) 
        }); 
    }
    
    public getStatus( ) : Promise<any> { 
        return  new Promise((resolve, reject) => {
            this.getAxios().get( this.url  + '/GetStatus'   , {}  )
            .then(response => {    
                resolve( response.data);  
            })
            .catch(error => {  
                reject(error.response);
            }) 
        }); 
    }
   
    public getModelLink( id  ) : Promise<any> { 
        return  new Promise((resolve, reject) => {
            this.getAxios().get( this.url + '/' + id  + '/link'   )
            .then(response => {    
                resolve( response.data);  
            })
            .catch(error => {  
                reject(error.response);
            }) 
        }); 
    }  

   
    public getModel( id  ) : Promise<any> { 
        return  new Promise((resolve, reject) => {
            this.getAxios().get( this.url + '/' + id    )
            .then(response => {    
                resolve( response.data);  
            })
            .catch(error => {  
                reject(error.response);
            }) 
        }); 
    }  


}
  
export default QtsPdfService; 